module.exports = __webpack_public_path__ + "static/media/yellowstone.65a6b792.jpg";